import { render, staticRenderFns } from "./IconGoogle.vue?vue&type=template&id=75415f7f&functional=true"
import script from "./IconGoogle.vue?vue&type=script&lang=js"
export * from "./IconGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports